import formatDate from 'date-fns/format';
import { getTrackDuration } from './get-track-duration';

export const getTrackDetails = ({ t, pages, duration, createdDate, contentType }) =>
  `${getTrackDuration({ t, pages, duration, contentType })}${
    createdDate ? ` • ${formatDate(new Date(createdDate), 'MMM d yyyy')}` : ''
  }`;
